import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { ImageCropDialogComponent } from './image-crop-dialog.component';
import { ImageCropOptions } from './image-crop-dialog.model';

@Injectable()
export class ImageCropDialogService {
  constructor(private readonly dialog: MatDialog) {}

  readonly onCrop$ = new Subject<Blob>();

  showCropper(imageChangedEvent: Event, options: ImageCropOptions = {}) {
    if ((imageChangedEvent.target as HTMLInputElement).files?.length === 0) {
      return;
    }

    this.dialog.open<ImageCropDialogComponent>(ImageCropDialogComponent, {
      data: {
        imageChangedEvent,
        options,
        onCrop: this.onCrop$,
      },
    });
  }

  onCrop(): Observable<Blob> {
    return this.onCrop$.asObservable();
  }

  onClose(): Observable<void> {
    return this.dialog.afterAllClosed;
  }
}
